import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.bulk-verification-csv', {
        url: '/bulk-verification-csv',
        views: {
            '@company.user-directories.directory-groups': 'companyUserDirectoriesDirectoryGroupsDirectoryBulkVerificationCsv'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification-csv/bulk-verification-csv.state.js